import { Trans } from 'react-i18next';
import '@cyberint/integrations/translate';
import * as S from './styled';

export const REGISTRATION_NOT_COMPLETED = 'REGISTRATION_NOT_COMPLETED';
export const NEW_COURSE_ASSIGNED = 'NEW_COURSE_ASSIGNED';
export const COURSE_INCOMPLETE = 'COURSE_INCOMPLETE';

const Link = ({ href, onClick, children }) => (
  <S.Link href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
    {children}
  </S.Link>
);

export const getText = ({ type, courseName, link, onClick }) => {
  switch (type) {
    case REGISTRATION_NOT_COMPLETED:
      return {
        title: <Trans i18nKey="integrations.litmos.registration_not_completed_title" />,
        message: (
          <Trans
            i18nKey="integrations.litmos.registration_not_completed_msg"
            components={{ action: <S.LinkedButton onClick={onClick} /> }}
          />
        )
      };
    case NEW_COURSE_ASSIGNED:
      return {
        title: <Trans i18nKey="integrations.litmos.new_course_assigned_title" />,
        message: (
          <Trans
            i18nKey="integrations.litmos.new_course_assigned_msg"
            values={{ courseName }}
            components={{ action: <Link href={link} onClick={onClick} /> }}
          />
        )
      };
    case COURSE_INCOMPLETE:
      return {
        title: <Trans i18nKey="integrations.litmos.course_incomplete_title" />,
        message: (
          <Trans
            i18nKey="integrations.litmos.course_incomplete_msg"
            components={{ action: <Link href={link} onClick={onClick} /> }}
          />
        )
      };
    default:
      return {
        message: '',
        title: ''
      };
  }
};
